/*
 * @Author: bianbinbin
 * @Date: 2024-12-26 10:10:15
 * @LastEditors: bianbinbin
 * @LastEditTime: 2025-01-09 16:01:31
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/annualReport.js
 */
const annualReport = r => require.ensure([], () => r(require('@/views/annualReport/annualReport.vue'), 'annualReport'))
// somebody's annual report 领导的年度报告
const leadAnnualReport = r => require.ensure([], () => r(require('@/views/leadAnnualReport/index.vue'), 'leadAnnualReport'))

const router = [
  {
    path: '/annualReport',
    name: 'annualReport',
    meta: {
      title: '年度报告'
    },
    component: annualReport
  },
  {
    path: '/leadAnnualReport',
    name: 'leadAnnualReport',
    meta: {
      title: '年度报告'
    },
    component: leadAnnualReport
  }
]

export default router
